import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

const CalculatorIcon: FC<SvgIconProps> = ({ className }) => {
  return (
    <SvgIcon
      className={className}
      width="359.741"
      height="359.741"
      viewBox="0 0 359.741 359.741"
    >
      <g>
        <g>
          <path
            d="M299.855,0H59.885C32.307,0,9.87,22.435,9.87,50.015v259.71c0,27.578,22.437,50.016,50.015,50.016h239.971
			c27.578,0,50.015-22.438,50.015-50.016V50.015C349.87,22.435,327.433,0,299.855,0z M120.014,312.986c0,2.09-1.7,3.79-3.79,3.79
			H70.353c-2.09,0-3.792-1.7-3.792-3.79v-45.871c0-2.09,1.702-3.792,3.792-3.792h45.871c2.09,0,3.79,1.702,3.79,3.792V312.986z
			 M120.014,222.444c0,2.091-1.7,3.791-3.79,3.791H70.353c-2.09,0-3.792-1.7-3.792-3.791v-45.871c0-2.091,1.702-3.792,3.792-3.792
			h45.871c2.09,0,3.79,1.701,3.79,3.792V222.444z M210.558,312.986c0,2.09-1.702,3.79-3.793,3.79h-45.871
			c-2.09,0-3.792-1.7-3.792-3.79v-45.871c0-2.09,1.701-3.792,3.792-3.792h45.871c2.091,0,3.793,1.702,3.793,3.792V312.986z
			 M210.558,222.444c0,2.091-1.702,3.791-3.793,3.791h-45.871c-2.09,0-3.792-1.7-3.792-3.791v-45.871
			c0-2.091,1.701-3.792,3.792-3.792h45.871c2.091,0,3.793,1.701,3.793,3.792V222.444z M300.702,313.256
			c0,2.092-1.702,3.791-3.792,3.791h-45.871c-2.09,0-3.791-1.699-3.791-3.791V176.574c0-2.091,1.7-3.792,3.791-3.792h45.871
			c2.09,0,3.792,1.701,3.792,3.792V313.256z M308.631,81.787c0,20.806-16.925,37.73-37.729,37.73H88.839
			c-20.806,0-37.73-16.925-37.73-37.73v-4.383c0-20.806,16.924-37.73,37.73-37.73h182.063c20.805,0,37.729,16.925,37.729,37.73
			V81.787L308.631,81.787z"
          />
        </g>
      </g>
    </SvgIcon>
  )
}

export default CalculatorIcon
